import { SidenavItemInterface } from "src/app/shared/side-nav/interfaces/side-nav-items.interface";
import { EAdminPermission } from "src/app/core/enums/admin-permission.enum";

export const managementSideNavConfig: SidenavItemInterface[] = [
  {
    id: 'recipients',
    label: 'recipients',
    routerLink: '/recipients',
    permissions: EAdminPermission.LIST_USERS,
  },
  {
    id: 'providers',
    label: 'providers',
    routerLink: '/providers',
    permissions: EAdminPermission.LIST_USERS,
  },
  {
    id: 'transactions',
    label: 'transactions',
    routerLink: '/transactions',
    permissions: EAdminPermission.LIST_TRANSACTIONS,
  },
  {
    id: 'applications',
    label: 'applications',
    routerLink: '/applications',
    permissions: EAdminPermission.LIST_APPLICATIONS,
  },
  {
    id: 'subscriptions',
    label: 'subscriptions',
    routerLink: '/subscriptions',
    permissions: EAdminPermission.LIST_SUBSCRIPTIONS,
  },
  {
    id: 'accounts',
    label: 'accounts',
    routerLink: '/accounts',
    permissions: EAdminPermission.LIST_USERS,
  },
  {
    id: 'masri-credit-report',
    label: 'masri_info_report',
    routerLink: '/masri-info-report',
    permissions: EAdminPermission.LIST_MASRI_CREDIT_REPORTS,
  },
  {
    id: 'ratings',
    label: 'ratings',
    routerLink: '/ratings',
    permissions: EAdminPermission.LIST_RATINGS,
  },
  {
    id: 'payments',
    label: 'payments',
    routerLink: '/payments',
    permissions: EAdminPermission.LIST_PAYMENT_TRANSACTIONS,
  },

];
